export default {
  paywall: {
    actions: {
      notNow: "Agora não",
      noThanks: "Não, obrigado",
      skip: "Pular",
    },
    generic: {
      title: "Desbloqueie a experiência completa",
      subtitle: "Acesse tudo de que precisa para pesquisar, montar e fazer apostas mais inteligentes",
      whyJoin: "Por que entrar no Linemate+?",
      comparePlans: "Comparar planos",
      renewalDisclaimer: "O plano renova automaticamente. Cancele quando quiser.",
    },
    sources: {
      injuryImpact: {
        title: "Desbloquear impacto de lesões",
        subtitle: "Veja como lesões impactam companheiros de equipe.\nAprofunde-se em cada tendência",
      },
      startingLineups: {
        title: "Desbloquear escalações iniciais",
        subtitle: "Encontre valor quando as escalações iniciais mudarem.\nAprofunde-se em cada tendência",
      },
      opponentRank: {
        title: "Desbloquear ranking defensivo do adversário",
        subtitle: "Explore confrontos defensivos favoráveis.\nAprofunde-se em cada tendência",
      },
      weatherReport: {
        title: "Desbloquear relatório do tempo",
        subtitle: "Use vento e clima a seu favor.\nAprofunde-se em cada tendência",
      },
      startingPitchers: {
        title: "Desbloquear arremessadores titulares adversários",
        subtitle: "Mire oportunidades contra arremessadores vulneráveis.\nAprofunde-se em cada tendência",
      },
    },
    features: {
      injuryImpact: {
        title: "Impacto de lesões",
        description: "Veja como lesões impactam companheiros de equipe.",
      },
      startingLineups: {
        title: "Escalações iniciais",
        description: "Encontre valor quando as escalações iniciais mudarem.",
      },
      opponentRank: {
        title: "Ranking defensivo do adversário",
        description: "Explore confrontos defensivos favoráveis.",
      },
      weatherReport: {
        title: "Relatório do tempo",
        description: "Use vento e clima a seu favor.",
      },
      startingPitchers: {
        title: "Arremessadores titulares adversários",
        description: "Mire oportunidades contra arremessadores vulneráveis.",
      },
    },
    comparison: {
      title: "Recursos",
      free: "Grátis",
      rows: {
        dailyTeamAndPlayerTrends: "Tendências diárias de equipes e jogadores",
        dailyParlayTrends: "Tendências diárias de parlay",
        teamAndPlayerPropsTool: "Ferramenta de props de equipes e jogadores",
        statsAndStandings: "Estatísticas e classificação",
        dailyCheatsheets: "Guias rápidos diários",
        advancedSignalsAndTools: "Sinais e ferramentas avançados",
        startingLineups: "Escalações iniciais",
        injuryImpact: "Impacto de lesões",
        opponentDefensiveRank: "Ranking defensivo do adversário",
        weatherReports: "Relatórios do tempo",
        startingOpponentPitchers: "Arremessadores titulares adversários",
      },
    },
    plans: {
      bestValue: "Melhor valor",
      annual: "Anual",
      monthly: "Mensal",
      yearlyPlan: "Plano anual",
      monthlyPlan: "Plano mensal",
      perYearShort: "ano",
      perMonthShort: "mês",
    },
    onboarding: {
      trialTitle: "Comece seu teste grátis de 7 dias",
      trialSubtitle: "Escolha um plano para continuar após o fim do teste",
    },
    cta: {
      claimYourCode: "Resgatar seu código",
      startYourFreeTrial: "Comece seu teste grátis",
      startMy7DayFreeTrial: "Começar meu teste grátis de 7 dias",
      tryFreeAndSubscribe: "Testar grátis e assinar",
      upgradeToLinematePlus: "Fazer upgrade para Linemate+",
    },
    trial: {
      sevenDaysFree: "7 dias grátis",
      thenPerMonth: "{{trial}}, depois {{price}} por mês",
      thenPerYear: "{{trial}}, depois {{price}} por ano ({{monthlyPrice}}/{{perMonthShort}})",
      startingOn: " a partir de {{date}}",
      standardPerMonth: "{{price}} por mês",
      standardPerYear: "{{price}} por ano ({{monthlyPrice}}/{{perMonthShort}})",
      subtitleSuffix: " com teste grátis de 7 dias.",
    },
  },
};
